import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Configuration} from '../config/config';
import 'rxjs/add/operator/map';

@Injectable()
export class LicenseService {

  public jwtToken: string;

  constructor(private http:HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  saveLicense(licenseObj){


    return this.http.post(Configuration.ServerWithApiUrl+'/license', licenseObj)
      .map((res: any)=>res)
  }

  deleteLicense(obj){


    return this.http.put(Configuration.ServerWithApiUrl+'/license/'+obj.licence_id, obj)
      .map((res: any)=>res)
  }

  getLicenseById(license_arr){

    return this.http.post(Configuration.ServerWithApiUrl+'/licenseById',license_arr)
      .map((res: any)=>res)
  }

  saveLicenseForUser(Obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/saveLicenseForUser',Obj)
      .map((res: any)=>res)
  }

  assignLicenseToGlobal(licenseObj){


    return this.http.post(Configuration.ServerWithApiUrl+'/saveLicenseForGlobal',licenseObj)
      .map((res: any)=>res)
  }

  saveLicenseCommunity(obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/saveLicenseCommunity',obj)
      .map((res: any)=>res)
  }

  getCouponsByCode(code,communityId){

    return this.http.get(Configuration.ServerWithApiUrl+'/getCouponByCode/'+code+'/'+communityId)
      .map((res: any)=>res)
  }

  updateUsedCoupos(data){


    return this.http.put(Configuration.ServerWithApiUrl+'/coupons',data)
      .map((res: any)=>res)
  }

  getLicenseByCommunityID(community_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/getLicenseList_by_commID/'+community_id)
      .map((res: any)=>res)
  }

  getTerm(){


    return this.http.get(Configuration.ServerWithApiUrl+'/term')
      .map((res: any)=>res)
  }

  payPalTransaction(obj, redirectFlag){


    return this.http.get(Configuration.Server+'buy/'+obj.price+'/'+ redirectFlag)
      .map((res: any)=>res)
  }

  // add selected Courses in batch

  addCourseData(courseObj){


    return this.http.post(Configuration.ServerWithApiUrl+'/addCourseToBatch',courseObj)
      .map((res: any)=>res)
  }
  addJourneyData(JourneyObj){


    return this.http.post(Configuration.ServerWithApiUrl+'/addJourneyToBatch',JourneyObj)
      .map((res: any)=>res)
  }

  // add selected Certificates in batch

  addCertificateData(certificateObj){


    return this.http.post(Configuration.ServerWithApiUrl+'/addCertificateToBatch',certificateObj)
      .map((res: any)=>res)
  }

  addCertificateDataToUnorganized(certificateObj){


    return this.http.post(Configuration.ServerWithApiUrl+'/addSelectedCertificatesForUnorganizedUsers',certificateObj)
      .map((res: any)=>res)
  }

  getCommunityByCommunityID(communityID){


    return this.http.get(Configuration.ServerWithApiUrl+'/communities/'+communityID)
      .map((res: any)=>res)
  }

  updateSubscribedLicence(data){

    return this.http.put(Configuration.ServerWithApiUrl+'/updateLicenseForUserTransaction', data)
      .map((res: any)=>res)
  }

  getLicenseByLicenseId(id){

    return this.http.get(Configuration.ServerWithApiUrl+ '/licensebyid/'+id)
      .map((res: any)=>res)
  }

  updateLicense(Obj){

    return this.http.put(Configuration.ServerWithApiUrl+ '/license', Obj)
      .map((res: any)=>res)
  }

  getAllCommunities(){


    return this.http.get(Configuration.ServerWithApiUrl+'/communitiesnames')
      .map((res: any)=>res)
  }
  getCommunityAdmin(commid){


    return this.http.get(Configuration.ServerWithApiUrl+'/getCommunityAdmin/'+commid)
      .map((res: any)=>res)
  }
  getCourseNCerficate(licenseId){


    return this.http.get(Configuration.ServerWithApiUrl+'/getCourseAndLicense/'+licenseId)
      .map((res: any)=>res)
  }
  getSubscribedCourseAndLicense(licence_user_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/getSubscribedCourseAndLicense/'+licence_user_id)
      .map((res: any)=>res)
  }

  getCommunityByName(name){


    return this.http.get(Configuration.ServerWithApiUrl+ '/getCommunityByName/'+name)
      .map((res: any)=>res)
  }
  updateSubscribeLicense(data){


    return this.http.put(Configuration.ServerWithApiUrl+'/updateLicenseForUser',data)
      .map((res: any)=>res)
  }
  deleteExpiryMessages(licence_user_id,user_id){


    return this.http.delete(Configuration.ServerWithApiUrl+'/deleteExpiryMessage/'+licence_user_id+'/'+user_id)
      .map((res: any)=>res)
  }

  checkPassword(obj){


    return this.http.post(Configuration.ServerWithApiUrl+ '/confirmPassword', obj)
      .map((res: any)=>res)
  }
  getSubscribedUsers(licenseuser_id){


    return this.http.get(Configuration.ServerWithApiUrl+ '/getSubscribedUsers/'+licenseuser_id)
      .map((res: any)=>res)
  }

  getCommunityCourses(community_id){


    return this.http.get(Configuration.ServerWithApiUrl+ '/getCommunityCourses/'+community_id)
      .map((res: any)=>res)
  }
  getCommunityJourneys(community_id){


    return this.http.get(Configuration.ServerWithApiUrl+ '/getCommunityJourneys/'+community_id)
      .map((res: any)=>res)
  }
  getCommunityCertificates(community_id){


    return this.http.get(Configuration.ServerWithApiUrl+ '/getCommunityCertificates/'+community_id)
      .map((res: any)=>res)
  }

  cleareTable(){
    let data = {};
    return this.http.post(Configuration.ServerWithApiUrl+ '/clearDatatable', data)
      .map((res: any)=>res)
  }
  checkSubscribedforRelatedCourse(data){

    return this.http.post(Configuration.ServerWithApiUrl+ '/checkSubscribedforRelatedCourse', data)
      .map((res: any)=>res)
  }

  getLicenseDetailsById(id){

    return this.http.get(Configuration.ServerWithApiUrl+ '/license/'+id)
      .map((res: any)=>res)
  }

  getCoursesForRespectiveCommunity(comm_id, flag){

    return this.http.get(Configuration.ServerWithApiUrl+ '/content_for_community/'+comm_id + '/' + flag)
      .map((res: any)=>res)
  }

  getResctiveContentForEditCommunity(obj){

    return this.http.post(Configuration.ServerWithApiUrl+ '/content_for_community_edit', obj)
      .map((res: any)=>res)
  }

  subscribedUsersByAdmin(id){

    return this.http.get(Configuration.ServerWithApiUrl+ '/subscribedUsersByAdmin/'+id)
      .map((res: any)=>res)
  }

  unsubscribeLicense(data){

    return this.http.post(Configuration.ServerWithApiUrl+ '/unsubscribeLicense', data)
      .map((res: any)=>res)
  }

}




// WEBPACK FOOTER //
// ./src/app/Services/license.service.ts